<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-0 lg:py-0 px-6 flex align-items-center justify-content-between lg:static">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-8', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
        </div>
        <div id="navbar-8"
             class="py-0 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverviewHome" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Home</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewAuditTrail" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Audit Trail</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewTasks" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Tasks</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewProcesses" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Processes</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewDashboard" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Dashboards</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewReports" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Reports</span>
                    </a>
                </li>
                <li>
                    <a @click="commonOverviewFiles" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Files</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[MenuHealthOverview][mounted] System is active.");
                console.log("[MenuHealthOverview][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[MenuHealthOverview][mounted] System is NOT active.");
                console.log("[MenuHealthOverview][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuHealthOverview][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[MenuHealthOverview][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[MenuHealthOverview][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[MenuHealthOverview][mounted] No user data found.");
                    console.log("[MenuHealthOverview][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processOverviewHome() {
            console.log("[MenuHealthOverview][processOverviewHome] Beginning.");

            if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
                window.location.href = "/#/faOverviewHome";
            } else {
                window.location.href = "/#/sbOverviewHome";
            }

        },
        processOverviewAuditTrail() {
            console.log("[MenuHealthOverview][processOverviewAuditTrail] Beginning.");
            window.location.href = "/#/commonOverviewAuditTrail";
        },
        processOverviewDashboard() {
            console.log("[MenuHealthOverview][processOverviewDashboard] Beginning.");
            window.location.href = "/#/commonOverviewDashboard";

            // if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
            //     window.location.href = "/#/faOverviewDashboard";
            // } else {
            //     window.location.href = "/#/sbOverviewDashboard";
            // }

        },
        processOverviewReports() {
            console.log("[MenuHealthOverview][processOverviewReports] Beginning.");
            window.location.href = "/#/commonOverviewReports";

            // if (this.userStore.user.roles.includes('ROLE_ISORISE', 0)) {
            //     window.location.href = "/#/faOverviewReports";
            // } else {
            //     window.location.href = "/#/sbOverviewReports";
            // }

        },
        commonOverviewFiles() {
            console.log("[MenuHealthOverview][commonOverviewFiles] Beginning.");
            window.location.href = "/#/commonOverviewFiles";
        },
        processOverviewTasks() {
            console.log("[MenuHealthOverview][processOverviewTasks] Beginning.");
            window.location.href = "/#/commonOverviewTasks";
        },
        processOverviewProcesses() {
            console.log("[MenuHealthOverview][processOverviewProcesses] Beginning.");
            window.location.href = "/#/commonOverviewProcesses";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
